module.exports = __webpack_public_path__ + "img/header-engagementRingsDiamonds.55cf49f.webp";